export enum Side {
  Front = 'FRONT',
  Back = 'BACK',
}

export enum Direction {
  Vertical = 'vertical',
  Horizontal = 'horizontal',
}

export const getOrdinal = <TEnum extends object>(
  _enum: TEnum,
  value: any,
): number => Object.keys(_enum).indexOf(value);

export const getByOrdinal = <TEnum extends object>(
  _enum: TEnum,
  index: number,
): TEnum[keyof TEnum] => Object.values(_enum)[index];
